import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromAppRoot from '@app/app.reducers';

@Injectable({
  providedIn: 'root'
})
class StrategyGuardService {
  constructor(
    private router: Router,
    private store: Store
  ) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Observable((observer) => {
      this.store.pipe(select(fromAppRoot.selectCustomerAndCurrentAccount)).subscribe((value) => {
        const isGrowAccount = value?.currentAccountDetail?.kind === 'grow';
        if (isGrowAccount) {
          void this.router.navigate(['/']);
          observer.next(false);
        } else {
          observer.next(true);
        }
      });
    });
  }
}

export const StrategyGuard: CanActivateFn = () => {
  return inject(StrategyGuardService).canActivate();
};
